/**
 * HubSpot deployment type values for tracking user deployment activity.
 *
 * IMPORTANT: When adding a new deployment type:
 * 1. Add the value to this constant object
 * 2. Ensure all deployment actions call useDeploymentTracking().trackDeployment()
 * 3. Update the DevOps Center mapping if applicable (PageHeader.tsx)
 *
 * These values are sent to HubSpot as the `last_deploy_type` property
 */
export const DEPLOY_TYPE_VALUES = {
  AUTOMATIONS: 'automations',
  ALERTS: 'alerts',
  ASSIGNMENTS: 'assignments',
  DEDUPE_MATCHING: 'dedupe_matching',
  SCHEDULED_ASSIGNMENTS: 'scheduled_assignments',
  ROLLUPS: 'rollups',
  SCHEDULED_REPORTS: 'scheduled_reports',
  SCHEDULED_JOBS: 'scheduled_jobs',
  FIELDS: 'fields',
  FUNNELS: 'funnels',
  CAMPAIGNS: 'campaigns',
  MARKETING_ATTRIBUTION: 'marketing_attribution',
} as const;

export type DeployTypeValue = typeof DEPLOY_TYPE_VALUES[keyof typeof DEPLOY_TYPE_VALUES];
